"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SkeletonRows = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var types = _interopRequireWildcard(require("../../../constants"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SkeletonRows = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonRows, _Component);

  var _super = _createSuper(SkeletonRows);

  function SkeletonRows() {
    _classCallCheck(this, SkeletonRows);

    return _super.apply(this, arguments);
  }

  _createClass(SkeletonRows, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          defaultRowClasses = _this$props.defaultRowClasses,
          tableActions = _this$props.tableActions,
          _this$props$tableData = _this$props.tableData,
          actions = _this$props$tableData.actions,
          columns = _this$props$tableData.columns,
          selectEnabled = _this$props$tableData.selectEnabled;
      var rowColumns = tableActions.getVisibleColumns(columns).map(function (column, index) {
        // eslint-disable-next-line array-callback-return
        if (!column.show) return; // if column.show is false, do not load the column

        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "".concat(index, "_").concat(column.key)
        }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, null));
      });
      var hasMenuColumn = false;
      actions.forEach(function (action, index) {
        !hasMenuColumn && // only add cell if not an additional menu type option
        rowColumns.push( /*#__PURE__*/_react["default"].createElement("td", {
          key: "".concat(index, "_").concat(action.icon)
        }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, null)));
        hasMenuColumn = action.type === types.ROW_MENU || hasMenuColumn; // if menu type option, set as true
      });

      if (selectEnabled) {
        rowColumns.unshift( /*#__PURE__*/_react["default"].createElement("td", {
          key: "select"
        }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, null)));
      }

      return [/*#__PURE__*/_react["default"].createElement("tr", {
        key: "skeleton1",
        className: defaultRowClasses.tableRow
      }, rowColumns), /*#__PURE__*/_react["default"].createElement("tr", {
        key: "skeleton2",
        className: defaultRowClasses.tableRow
      }, rowColumns), /*#__PURE__*/_react["default"].createElement("tr", {
        key: "skeleton3",
        className: defaultRowClasses.tableRow
      }, rowColumns), /*#__PURE__*/_react["default"].createElement("tr", {
        key: "skeleton4",
        className: defaultRowClasses.tableRow
      }, rowColumns)];
    }
  }]);

  return SkeletonRows;
}(_react.Component);

exports.SkeletonRows = SkeletonRows;

_defineProperty(SkeletonRows, "propTypes", {
  // from TableRows
  defaultRowClasses: _propTypes["default"].object.isRequired,
  tableActions: _propTypes["default"].shape({
    getVisibleColumns: _propTypes["default"].func.isRequired
  }).isRequired,
  tableData: _propTypes["default"].shape({
    actions: _propTypes["default"].array.isRequired,
    columns: _propTypes["default"].array.isRequired,
    selectEnabled: _propTypes["default"].bool
  }).isRequired
});

var _default = SkeletonRows;
exports["default"] = _default;